import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatoriComponent } from './operatori.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { EditOperatorComponent } from './edit-operator/edit-operator.component';
import { UpdateFunctieOperatorComponent } from './update-functie-operator/update-functie-operator.component';
import { UpdateFunctiiMultipleOperatorComponent } from './update-functii-multiple-operator/update-functii-multiple-operator.component';
import { AlocareDirectieComponent } from './alocare-directie/alocare-directie.component';
import { AddAlocareDirectieComponent } from './alocare-directie/add-alocare-directie/add-alocare-directie.component';

@NgModule({
    declarations: [OperatoriComponent, EditOperatorComponent, UpdateFunctieOperatorComponent, UpdateFunctiiMultipleOperatorComponent, AlocareDirectieComponent, AddAlocareDirectieComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
    exports: [OperatoriComponent],
})
export class OperatoriModule { }
